export default "__VITE_ASSET__CnrV3o4v__"